import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import './styles.css';

export default function Pdpa() {
  return (
    <Typography component="div" variant="body1">
      <Box>
        <iframe width="100%" height="vw" src="https://pdpa.hii.or.th/privacy-policy/ntw/" title="นโยบายการคุ้มครองข้อมูลส่วนบุคคล" />
      </Box>
    </Typography>
  );
}
